import { render, staticRenderFns } from "./PostJournal.vue?vue&type=template&id=3d299fa8&scoped=true"
import script from "./PostJournal.vue?vue&type=script&lang=js"
export * from "./PostJournal.vue?vue&type=script&lang=js"
import style0 from "./PostJournal.vue?vue&type=style&index=0&id=3d299fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d299fa8",
  null
  
)

export default component.exports